import React from "react";

export default function Pagination ({page, setPage, totalPages}) {

    return (
        <div className="flex justify-center items-center gap-2 m-6">

            <button
                disabled={page === 1}
                onClick={() => setPage(page - 1)}
                className="px-3 py-1 text-[#1E3A5F] border border-[#1E3A5F] rounded disabled:opacity-40"
            >
                قبلی
            </button>

            {[...Array(totalPages || 1)].map((_, index) => {
                const pageNumber = index + 1;

                return (
                    <button
                        key={pageNumber}
                        onClick={() => setPage(pageNumber)}
                        className={`px-3 py-1 rounded ${
                            page === pageNumber
                                ? "bg-[#1E3A5F] text-[#FFC107]"
                                : "bg-[#F5F5F5] text-[#1E3A5F] hover:bg-[#DBDBDB] hover:text-[#12233A]"
                        }`}
                    >
                        {pageNumber}
                    </button>
                );
            })}

            <button
                disabled={page === totalPages}
                onClick={() => setPage(page + 1)}
                className="px-3 py-1 text-[#1E3A5F] border border-[#1E3A5F] rounded disabled:opacity-40"
            >
                بعدی
            </button>

        </div>
    )
}